import { computed, defineComponent, inject } from 'vue';
import { defaultConfigProvider, useConfigProvider } from '../config-provider';
export default defineComponent({
  name: 'Abstract',
  data: function data() {
    return {
      configProvider: inject('stepConfigProvider', defaultConfigProvider),
      className: 'abstract'
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      var configProvider = this.configProvider;
      var getPrefixCls = configProvider.getPrefixCls;
      return getPrefixCls(this.className);
    }
  }
});
export function useStyleConfig(className) {
  var configProvider = useConfigProvider();
  var prefixCls = computed(function () {
    return configProvider.getPrefixCls(className);
  });
  var rootPrefix = computed(function () {
    return configProvider.prefix;
  });
  return {
    prefixCls: prefixCls,
    rootPrefix: rootPrefix
  };
}